import { render } from "./Sales.vue?vue&type=template&id=5bd3ca26"
import script from "./Sales.vue?vue&type=script&lang=js"
export * from "./Sales.vue?vue&type=script&lang=js"
script.render = render

export default script